import connector from "service/connector";

const getBanner = async () => {
  return await connector.connectFetchController("banner", "GET");
}

export { getBanner };
export default { getBanner };